import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import { Button, TextInput, required, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";

const TopicEditDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record?.id) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.updateDoctorantTopic(record.id),
      {
        topic: data.topic,
        orderNumber: data.orderNumber,
        orderDate: data.orderDate,
      },
      "PUT",
    );
    notify("Темата на дисертацията е обновена успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на тема на дисертацията"
      saveTitle="Запази"
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{ topic: record.topic }}
      triggerButton={
        <Button
          label="Редактирай"
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="topic"
            label="Тема на дисертацията"
            validate={required("Задължително")}
            multiline
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="orderNumber"
            label="Номер на заповед"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="orderDate"
            label="Дата на заповед"
            validate={required("Задължително")}
            noTime
            fullWidth
            required
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default TopicEditDialog;
